import { create } from 'zustand'
import type { ActionSnackbarStore } from './type'

export const useActionStore = create<ActionSnackbarStore>((set) => ({
  action: null,
  setAction: (action) => set(() => ({ action })),
}))
